class SGCartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
      if (!this.eventsBound) {
          this.bindEvents();
          this.eventsBound = true;
      }
      this.reinitialize();
  }

  // Shopify Javascript API Compatibility for Product Form
  getSectionsToRender() { return []; }
  
  renderContents(parsedState) {
    if (parsedState && parsedState.sections) {
      this.renderSections(parsedState);
    } else {
      this.fetchCart();
    }
    this.open();
  }

  renderSections(parsedState) {
    if (parsedState.sections && parsedState.sections['cart-drawer']) {
      const div = document.createElement('div');
      div.innerHTML = parsedState.sections['cart-drawer'];
      const newDrawer = div.querySelector('cart-drawer') || div.querySelector('sg-cart-drawer');
      if (newDrawer) {
        this.innerHTML = newDrawer.innerHTML;
        this.reinitialize();
      }
    }
  }
  
  setActiveElement(element) {}

  reinitialize() {
    this.inner = this.querySelector('.sg-cart-drawer__inner');
    // this.overlay = this.querySelector('.sg-cart-drawer__overlay');
    this.overlay = document.querySelector('.sg-cart-drawer__overlay, #sg-overlay');
    this.closeBtn = this.querySelector('.sg-cart-drawer__close');
    this.itemsWrapper = this.querySelector('.sg-cart-drawer__items-wrapper');
    this.checkoutBtn = this.querySelector('.sg-cart-drawer__checkout');
    
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    }
    if (this.overlay && this.dataset.clickToClose === 'true') {
      this.overlay.addEventListener('click', () => this.close());
    }

    if (this.checkoutBtn) {
       this.checkoutBtn.addEventListener('click', () => {
         window.location.href = '/checkout';
       });
    }
  }

  bindEvents() {
    // Open Drawer when icon is clicked
    const icon = document.querySelector('#cart-icon-bubble');
    if (icon) {
      const clonedIcon = icon.cloneNode(true);
      icon.parentNode.replaceChild(clonedIcon, icon);
      clonedIcon.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    // Listen to custom cart update event
    document.addEventListener('cart:updated', () => {
      this.fetchCart();
    });

    document.addEventListener('cart:refresh', (e) => {
      if (e.detail && e.detail.parsedState) {
        this.renderSections(e.detail.parsedState);
      } else {
        this.fetchCart();
      }
      this.open();
    });

    // Intercept Add to Cart globally
    this.interceptAddToCart();

    // Delegate events inside the drawer (Qty, Remove)
    this.addEventListener('click', this.handleDrawerClicks.bind(this));
    this.addEventListener('change', this.handleDrawerChange.bind(this));

    this.addEventListener('click', (e) => {
      if (!e.target.closest('.sg-cart-drawer__inner')) {
        this.close();
      }
    });
  }

  open() {
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.classList.add('is-active');
  document.querySelector('#sg-overlay')?.classList.add('is-active');
    
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';

    
  }

  close() {
    this.classList.remove('is-active');
    document.querySelector('#sg-overlay')?.classList.remove('is-active');
    
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    
    window.scrollTo(0, this.scrollPosition || 0);
  }

  async fetchCart() {
    this.classList.add('sg-loading');
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}?sections=cart-drawer,cart-icon-bubble`);
      if (!response.ok) throw new Error('Network response was not ok');
      const parsedState = await response.json();
      this.renderSections(parsedState);
    } catch (error) {
      console.error('Error fetching cart:', error);
    } finally {
      this.classList.remove('sg-loading');
    }
  }

  renderSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    // Update Drawer
    if (parsedState.sections['cart-drawer']) {
      const div = document.createElement('div');
      div.innerHTML = parsedState.sections['cart-drawer'];
      const newDrawer = div.querySelector('cart-drawer') || div.querySelector('sg-cart-drawer');
      if (newDrawer) {
        this.innerHTML = newDrawer.innerHTML;
        this.reinitialize();
      }
    }

    // Update Header Bubble (Real-time sync)
    if (parsedState.sections['cart-icon-bubble']) {
      const bubbleContainer = document.querySelector('#cart-icon-bubble');
      if (bubbleContainer) {
        bubbleContainer.innerHTML = parsedState.sections['cart-icon-bubble'];
      }
    }
  }

  async updateHeaderBubble() {
    // Deprecated in favor of multi-section rendering for performance
    this.fetchCart();
  }

  // handleDrawerClicks(e) {
  //   const target = e.target;
    
  //   const btnMinus = target.closest('.sg-cart-item__qty-btn--minus');
  //   if (btnMinus) {
  //     e.preventDefault();
  //     const input = btnMinus.nextElementSibling;
  //     let val = parseInt(input.value) || 1;
  //     if (val > 0) {
  //       input.value = val - 1;
  //       this.updateItemQty(input.dataset.key, input.value);
  //     }
  //     return;
  //   }

  //   const btnPlus = target.closest('.sg-cart-item__qty-btn--plus');
  //   if (btnPlus) {
  //     e.preventDefault();
  //     const input = btnPlus.previousElementSibling;
  //     let val = parseInt(input.value) || 1;
  //     input.value = val + 1;
  //     this.updateItemQty(input.dataset.key, input.value);
  //     return;
  //   }

  //   const btnRemove = target.closest('.sg-cart-item__remove');
  //   if (btnRemove) {
  //     e.preventDefault();
  //     this.updateItemQty(btnRemove.dataset.key, 0);
  //     return;
  //   }

  //   const btnAddRec = target.closest('.sg-rec-add');
  //   if (btnAddRec) {
  //     e.preventDefault();
  //     const variantId = btnAddRec.dataset.variant;
  //     if(variantId) {
  //       this.addVariantToCart(variantId);
  //     }
  //     return;
  //   }
  // }

  handleDrawerClicks(e) {
    const target = e.target;

    const btnMinus = target.closest('.sg-cart-item__qty-btn--minus');
    if (btnMinus) {
      e.preventDefault();
      const input = btnMinus.nextElementSibling;
      let val = parseInt(input.value) || 1;
      if (val > 1) {
        input.value = val - 1;
        this.updateItemQty(input.dataset.key, val - 1, input);
      } else {
        // qty going to 0 = remove, animate it out
        const itemEl = btnMinus.closest('.sg-cart-item');
        if (itemEl) {
          itemEl.style.transition = 'opacity 0.2s ease, max-height 0.3s ease, margin 0.3s ease';
          itemEl.style.overflow = 'hidden';
          itemEl.style.opacity = '0';
          itemEl.style.maxHeight = '0';
          itemEl.style.marginBottom = '0';
        }
        this.updateItemQty(input.dataset.key, 0, input, itemEl);
      }
      return;
    }

    const btnPlus = target.closest('.sg-cart-item__qty-btn--plus');
    if (btnPlus) {
      e.preventDefault();
      const input = btnPlus.previousElementSibling;
      let val = parseInt(input.value) || 1;
      input.value = val + 1;
      this.updateItemQty(input.dataset.key, val + 1, input);
      return;
    }

    const btnRemove = target.closest('.sg-cart-item__remove');
    if (btnRemove) {
      e.preventDefault();
      const itemEl = btnRemove.closest('.sg-cart-item');
      if (itemEl) {
        itemEl.style.transition = 'opacity 0.2s ease, max-height 0.3s ease, margin 0.3s ease';
        itemEl.style.overflow = 'hidden';
        itemEl.style.opacity = '0';
        itemEl.style.maxHeight = '0';
        itemEl.style.marginBottom = '0';
      }
      this.updateItemQty(btnRemove.dataset.key, 0, null, itemEl);
      return;
    }

    const btnAddRec = target.closest('.sg-rec-add');
    if (btnAddRec) {
      e.preventDefault();
      const variantId = btnAddRec.dataset.variant;
      if (variantId) this.addVariantToCart(variantId);
      return;
    }
  }

  handleDrawerChange(e) {
    if (e.target.classList.contains('sg-cart-item__qty-input')) {
      const input = e.target;
      let val = parseInt(input.value) || 0;
      this.updateItemQty(input.dataset.key, val);
    }
  }

  // async updateItemQty(key, quantity) {
  //   this.classList.add('sg-loading');
  //   try {
  //     const config = {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json'
  //       },
  //       body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer,cart-icon-bubble' })
  //     };
      
  //     const response = await fetch(`${window.routes?.cart_change_url || '/cart/change'}.js`, config);
  //     if (response.ok) {
  //       const parsedState = await response.json();
  //       this.renderSections(parsedState);
  //     }
  //   } catch (error) {
  //     console.error('Error updating quantity:', error);
  //   } finally {
  //     this.classList.remove('sg-loading');
  //   }
  // }

  async updateItemQty(key, quantity, input, itemEl) {
    // Debounce per item key to prevent rapid duplicate calls
    if (!this._qtyTimers) this._qtyTimers = {};
    clearTimeout(this._qtyTimers[key]);

    this._qtyTimers[key] = setTimeout(async () => {
      try {
        const response = await fetch(`${window.routes?.cart_change_url || '/cart/change'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer,cart-icon-bubble' })
        });

        if (!response.ok) {
          // Revert optimistic UI on failure
          if (itemEl) {
            itemEl.style.opacity = '1';
            itemEl.style.maxHeight = '';
            itemEl.style.marginBottom = '';
          }
          if (input) input.value = parseInt(input.value) + (quantity === 0 ? 1 : 0);
          return;
        }

        const parsedState = await response.json();

        if (quantity === 0) {
          // Wait for animation then re-render
          setTimeout(() => this.renderSections(parsedState), 320);
        } else {
          // Just update subtotal + progress bar + bubble silently, no full re-render
          this.updateSubtotal(parsedState.total_price);
          this.updateProgressBar(parsedState.total_price);
          if (parsedState.sections?.['cart-icon-bubble']) {
            const bubbleContainer = document.querySelector('#cart-icon-bubble');
            if (bubbleContainer) bubbleContainer.innerHTML = parsedState.sections['cart-icon-bubble'];
          }
        }
      } catch (error) {
        console.error('Error updating quantity:', error);
        if (itemEl) {
          itemEl.style.opacity = '1';
          itemEl.style.maxHeight = '';
          itemEl.style.marginBottom = '';
        }
      }
    }, 300); // 300ms debounce — waits for user to stop clicking before firing
  }

  updateSubtotal(totalPriceCents) {
    const subtotalEl = this.querySelector('.sg-cart-drawer__subtotal-price');
    if (subtotalEl && totalPriceCents !== undefined) {
      const formatted = window.Shopify?.formatMoney
        ? window.Shopify.formatMoney(totalPriceCents, '₹{{amount}}')
        : 'Rs. ' + (totalPriceCents / 100).toFixed(2);
      subtotalEl.textContent = formatted;
    }
  }

  updateProgressBar(totalPriceCents) {
    const wrapper = document.querySelector('#cart-progress-wrapper');
    if (!wrapper) return;

    const threshold = parseInt(wrapper.dataset.threshold) || 0;
    if (!threshold) return;

    const bar = document.querySelector('#cart-progress-bar');
    const message = wrapper.querySelector('.goal-message');
    const preGoalTemplate = wrapper.dataset.preGoalMessageTemplate || '';
    const postGoalMessage = wrapper.dataset.postGoalMessage || '';
    const moneyFormat = wrapper.dataset.moneyFormat || 'Rs. {{amount}}';

    // Calculate new percentage
    let percentage = Math.min((totalPriceCents / threshold) * 100, 100);
    let remaining = Math.max(threshold - totalPriceCents, 0);

    // Update bar width (CSS transition handles the smooth animation)
    if (bar) bar.style.width = percentage + '%';

    // Update wrapper class for color change
    if (percentage >= 100) {
      wrapper.classList.add('full');
      wrapper.classList.remove('not-full');
    } else {
      wrapper.classList.remove('full');
      wrapper.classList.add('not-full');
    }

    // Update message
    if (message) {
      if (remaining > 0) {
        // Format remaining amount using shop money format
        const formatted = moneyFormat.replace('{{amount}}', (remaining / 100).toFixed(2))
                                    .replace('{{amount_no_decimals}}', Math.floor(remaining / 100))
                                    .replace('{{amount_with_comma_separator}}', (remaining / 100).toFixed(2).replace('.', ','));
        message.innerHTML = preGoalTemplate.replace('[remainingForGoalFormatted]', formatted);
      } else {
        message.innerHTML = postGoalMessage;
      }
    }
  }

  async addVariantToCart(variantId) {
    this.classList.add('sg-loading');
    const btn = this.querySelector(`.sg-rec-add[data-variant="${variantId}"]`);
    if(btn) btn.textContent = 'Adding...';

    try {
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
      };
      
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, config);
      if (response.ok) {
        const parsedState = await response.json();
        this.renderSections(parsedState);
      }
    } catch (error) {
      console.error('Error adding variant:', error);
    } finally {
      if(btn) btn.textContent = 'Add';
      this.classList.remove('sg-loading');
    }
  }

  interceptAddToCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (form.getAttribute('action') && form.getAttribute('action').includes('/cart/add')) {
        e.preventDefault();
        
        const submitBtn = form.querySelector('[type="submit"]') || form.querySelector('button');
        const originalText = submitBtn ? submitBtn.innerHTML : '';
        if(submitBtn) submitBtn.innerHTML = 'Adding...';

        const formData = new FormData(form);
        // Request the sections in the same call for efficiency
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);

        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          
          if (response.ok) {
            const parsedState = await response.json();
            this.renderSections(parsedState);
            this.open();
          } else {
             alert('Sorry, there was an issue adding to cart.');
          }
        } catch(err) {
           console.error(err);
        } finally {
           if(submitBtn) submitBtn.innerHTML = originalText;
        }
      }
    });

    document.addEventListener('click', (e) => {
        const toggleCartBtn = e.target.closest('[data-cart-toggle]');
        if (toggleCartBtn) {
            e.preventDefault();
            this.open();
            return;
        }

        const addToCartLink = e.target.closest('a[href*="/cart/add"]');
        if (addToCartLink) {
             e.preventDefault();
             const url = new URL(addToCartLink.href, window.location.origin);
             const id = url.searchParams.get('id');
             const quantity = url.searchParams.get('quantity') || 1;
             if (id) {
                this.classList.add('sg-loading');
                const prevHtml = addToCartLink.innerHTML;
                addToCartLink.innerHTML = 'Adding...';
                const config = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: id, quantity: quantity, sections: 'cart-drawer,cart-icon-bubble' })
                };
                fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, config)
                  .then(response => response.json())
                  .then(parsedState => {
                      this.renderSections(parsedState);
                      this.open();
                  }).finally(() => { addToCartLink.innerHTML = prevHtml; this.classList.remove('sg-loading'); });
             }
        }
    });
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', SGCartDrawer);
}
